module.exports = __webpack_public_path__ + "static/media/question_cn.1898ed55.png";